import { render } from "./Manage.vue?vue&type=template&id=fe44b452&scoped=true&ts=true"
import script from "./Manage.vue?vue&type=script&lang=ts"
export * from "./Manage.vue?vue&type=script&lang=ts"

import "./Manage.vue?vue&type=style&index=0&id=fe44b452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe44b452"]])

export default __exports__